import { useCallback, useEffect, useState } from 'react'
import { fetchHarbourPulse } from 'src/utils/harbourApi'
import { HARBOUR_DEFAULT_PLAN_FILTER } from 'src/constants/harbour'

export const EMPTY_HARBOUR_PULSE = Object.freeze({
  paidAtRisk: 0,
  freeSlipping: 0,
  overdueFollowUps: 0,
  unclaimedNeedsYou: 0,
  snoozedThisWeek: 0,
  recoveredThisWeek: 0,
  forgotten: 0,
  needsYouCap: 30,
  overdueFollowUpsByOwner: {},
  forgottenByOwner: {},
})

/**
 * Pulse counts for the current plan filter. Disabled when the Harbour tab
 * is not showing so The Bridge does not fetch CS radar on Catch Board.
 */
export function useHarbourPulse({
  planFilter = HARBOUR_DEFAULT_PLAN_FILTER,
  enabled = true,
} = {}) {
  const [pulse, setPulse] = useState(EMPTY_HARBOUR_PULSE)
  const [loading, setLoading] = useState(Boolean(enabled))
  const [error, setError] = useState(null)
  const [reloadToken, setReloadToken] = useState(0)

  const refresh = useCallback(() => {
    setReloadToken(token => token + 1)
  }, [])

  useEffect(() => {
    if (!enabled) {
      return undefined
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    async function loadPulse() {
      try {
        const next = await fetchHarbourPulse({ planFilter })
        if (cancelled) {
          return
        }
        setPulse(next)
      } catch (err) {
        if (cancelled) {
          return
        }
        setPulse(EMPTY_HARBOUR_PULSE)
        setError(err.message || 'Failed to load Harbour pulse')
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadPulse()

    return () => {
      cancelled = true
    }
  }, [planFilter, enabled, reloadToken])

  return { pulse, loading, error, refresh }
}
